import { addToast } from "@heroui/react";

interface ToastMessages {
  pending?: string;
  success?: string;
  error?: string;
}

interface ToastOptions {
  title?: string;
  description?: string;
}

export const messagePromise = <T>(
  promise: Promise<T>,
  messages: string | ToastMessages,
  options?: ToastOptions
): Promise<T> => {
  // Normalizar el input de mensajes
  const normalizedMessages: ToastMessages = typeof messages === "string"
    ? { pending: messages }
    : messages;

  const pendingToast = {
    title: options?.title || normalizedMessages.pending,
    description: options?.description,
    promise: promise.then(
      (result) => {
        if (normalizedMessages.success) {
          addToast({
            title: normalizedMessages.success,
            color: "success",
          });
        }
        return result;
      },
      (error) => {
        if (normalizedMessages.error) {
          addToast({
            title: normalizedMessages.error,
            color: "danger",
          });
        }
        throw error;
      }
    ),
  };

  if (pendingToast.title || pendingToast.description) {
    addToast(pendingToast);
  } else {
    addToast({ promise: promise });
  }

  return promise;
};
